<template lang="pug">
  div
    v-tabs.tabs(:value="currentTab" background-color="#757575" color="#FFFFFF" slider-size="4" slider-color="#FFFFFF" height="42" dark centered grow)
      v-tab.text-none(@click="setPath(root.folder)") Документы
      v-tab.text-none(@click="setPath(root.tag)") Шаблоны

    v-tabs-items(:value="currentTab")
      v-tab-item
        file-store-explorer-path(v-for="item in sortedFolders" :key="item.id" :path="item" @click.native="setPath(item)" @delete="showDeleteDialoog" @edit="showEditDialog")

      v-tab-item
        file-store-explorer-path(v-for="item in sortedTags" :key="item.id" :path="item" @click.native="setPath(item)" @delete="showDeleteDialoog" @edit="showEditDialog")
    
    app-dialog-confirm(v-model="dialog.confirm" @confirm="deleteSelectedPath")
      app-card-title.mt-5 Вы точно хотите удалить {{ selectedPath.isTag ? 'тег' : 'папку' }} "{{ selectedPath.name }}"?

    app-dialog(v-model="dialog.move" :header="`Удаление ${selectedPath.isTag ? 'тега' : 'папки'} \"${selectedPath.name}\"`" confirm-text="Удалить" :confirm-disabled="!moveIsReady" @confirm="deleteSelectedPath")
      app-select(v-if="dialog.move" v-model="move.folder" :items="availablePathes" item-text="name" label="Куда перенести файлы?")

    app-dialog(v-model="dialog.rename" :header="`Переименование ${selectedPath.isTag ? 'тега' : 'папки'} \"${selectedPath.name}\"`" confirm-text="Переименовать" :confirm-disabled="!renameIsReady" @confirm="renameSelectedPath")
      app-text-field.mt-6(v-model="rename.name" label="Новое имя папки" counter="90" :error-text="renameError" clearable @keyup.enter="renameSelectedPath")
      
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import path from './FileStoreExplorerPath'

export default {
  name: 'file-store-explorer',
  components: {
    [path.name]: path
  },

  computed: {
    ...mapState('fileStore', ['root', 'path']),
    ...mapGetters('fileStore', ['sortedFolders', 'sortedTags', 'documentsByPath', 'templatesByPath']),

    currentTab () { return this.path.isTag ? 1 : 0 },

    selectedPath () { return this.processPath || {} },
    selectedPathHasFiles () {
      let files = this.selectedPath.isFolder ? this.documentsByPath(this.selectedPath) : this.templatesByPath(this.selectedPath)
      return (files.length > 0)
    },

    pathes () { return !this.selectedPath ? [] : this.selectedPath.isTag ? this.sortedTags : this.sortedFolders },
    availablePathes () { return this.pathes.filter(p => p.id !== this.selectedPath.id) },
    moveIsReady () { return this.move.folder || false },

    preparedName () { return this.rename.name ? this.rename.name.trim() : "" },
    isNameTooLarge () { return this.preparedName.length > 90 },
    isNameUnique () { return this.pathes.map(x => x.name.trim()).includes(this.preparedName) == false },
    renameIsReady () { return !this.isNameTooLarge && this.isNameUnique },
    renameError () { return this.isNameTooLarge ? "Слишком длинное название" : !this.isNameUnique ? `${this.selectedPath.isTag ? 'Тег' : 'Папка'} с таким именем уже существует` : null },
  },

  methods: {
    ...mapMutations('fileStore', ['setPath']),
    ...mapActions('fileStore', ['deletePath', 'updatePath']),

    showDeleteDialoog (path) {
      this.processPath = path
      if (this.selectedPathHasFiles) this.dialog.move = true
      else this.dialog.confirm = true
    },

    showEditDialog (path) {
      this.processPath = path
      this.rename.name = this.processPath.name
      this.dialog.rename = true
    },

    deleteSelectedPath () {
      let params = this.selectedPathHasFiles ? { path: this.selectedPath, target: this.move.folder } : { path: this.selectedPath }
      this.deletePath(params)
    },

    renameSelectedPath () {
      this.dialog.rename = false
      this.updatePath({ id: this.selectedPath.id, isTag: this.selectedPath.isTag, name: this.rename.name })
    }
  },

  data () {
    return {
      processPath: null,
      dialog: {
        confirm: false,
        move: false,
        rename: false
      },
      move: {
        folder: null
      },
      rename: {
        name: ""
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  border-bottom: 1px solid #FFFFFF;
  border-radius: 5px 5px 0px 0px;
}
</style>